import { TrackingSystemParameters } from '@poseidon/tracklib/lib/tracklib.systems';

export enum BannerTrackingEvent {
  'bannerDisplayed',
  'ctaButtonClicked',
  'closeButtonClicked'
}

export const bannerTrackingData: { [key in keyof typeof BannerTrackingEvent]: TrackingSystemParameters } = {
  bannerDisplayed: {
    section: 'nav.navigator.event.postavise.reminder.view'
  },
  ctaButtonClicked: {
    section: 'nav.navigator.event.postavise.reminder.tanentry.click',
    trackingtype: 'cl'
  },
  closeButtonClicked: {
    section: 'nav.navigator.event.postavise.reminder.close.click',
    trackingtype: 'cl'
  }
};
